exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-noInfo[data-v-cf97a2a8]{width:250px;height:auto}@media only screen and (min-width:450px){.svg-noInfo[data-v-cf97a2a8]{width:400px;height:auto}}.text-noInfo[data-v-cf97a2a8],.title-noInfo[data-v-cf97a2a8]{margin-top:12px;margin-bottom:0;padding:0}.text-noInfo[data-v-cf97a2a8]{color:grey}", ""]);

// exports
